import { jsx as _jsx } from "react/jsx-runtime";
import { mergeStyles } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const StyledSection = styled.ul `
  list-style: none;
  margin: ${({ theme }) => theme.spacing[200] + ' 0 0 0'};
  padding: ${({ theme }) => theme.spacing[200] + ' 0 0 0'};
  border-top: 1px solid ${({ theme }) => theme.color.border.interactiveBase};

  ${({ theme }) => theme.breakpoint.maxWidth('md')} {
    &:first-of-type {
      margin-top: ${({ theme }) => theme.spacing[0]};
    }
  }

  &.typehead-default-suggestion:not(:only-child) {
    display: none;
  }
`;
const StyledSectionTitle = styled.h4 `
  text-decoration: none;
  color: ${({ theme }) => theme.color.font.base};
  display: block;
  font-weight: ${({ theme }) => theme.typography.fontWeight.openSans.bold};
  padding: ${({ theme }) => theme.spacing[200] + ' ' + theme.spacing[400]};
  margin: 0;
  text-align: left;
  white-space: normal;
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
`;
export const SectionTitle = ({ children }) => (_jsx("li", { children: _jsx(StyledSectionTitle, { children: children }) }));
export const getResultContainerStyles = (theme) => {
    return mergeStyles([
        {
            position: 'absolute',
            left: 0,
            top: '100%',
            width: '100%',
            height: 'calc(100dvh - 4.4rem)',
            maxHeight: 'calc(100dvh - var(--cb-header-height-inner))',
            overflowX: 'hidden',
            overflowY: 'auto',
            background: theme.color.background.base,
            borderRadius: '0 0 4px 4px',
            padding: `${theme.spacing[0]} ${theme.spacing[0]} ${theme.spacing[200]}`,
            transformOrigin: 'top',
            '@keyframes scale-drop-down-typeahead': {
                '0%': {
                    transform: 'scale(1, 0.7)',
                },
            },
            animation: 'scale-drop-down-typeahead 0.25s cubic-bezier(0.1, 1.45, 0.35, 1)',
            [theme.breakpoint.maxWidth('md')]: {
                overflow: 'scroll',
                overscrollBehavior: 'contain',
            },
            [theme.breakpoint.minWidth('md')]: {
                width: 'calc(100% - 2.4rem)',
                top: 'calc(100% - 0.7rem)',
                left: '1.2rem',
                padding: `${theme.spacing[0]} ${theme.spacing[0]} ${theme.spacing[200]} ${theme.spacing[0]}`,
                height: 'auto',
            },
            '&:empty': {
                display: 'none',
            },
        },
    ]);
};
export const StyledSuggestion = styled.li `
  text-decoration: none;
  color: ${({ theme }) => theme.color.font.base};
  display: block;
  font-weight: 700;
  padding: ${({ theme }) => theme.spacing[200] + ' ' + theme.spacing[400]};
  margin: 0;
  cursor: pointer;
  text-align: left;
  white-space: normal;

  :hover {
    background-color: ${({ theme }) => theme.color.background.interactiveHovered};
  }

  & > a:only-child {
    text-decoration: none;
    display: block;
  }
`;
export const getTypeaheadStyles = (theme, isOpen) => {
    return mergeStyles([
        {
            position: 'relative',
            minHeight: '4rem',
            maxWidth: '56rem',
            width: '100%',
            transition: 'top 0.25s ease-in-out, background-color 0.25s ease-in-out',
            transitionDelay: 'top 0.25s',
            zIndex: '101',
            [theme.breakpoint.maxWidth('md')]: {
                position: isOpen ? 'fixed' : 'absolute',
                left: 0,
                top: isOpen ? 0 : 'var(--cb-header-height-inner)',
                backgroundColor: theme.color.background.secondary,
                marginLeft: isOpen ? 0 : 'calc(-1 * var(--cb-spec-container-horizontal-padding))',
                width: isOpen
                    ? '100%'
                    : 'calc(100% + calc(2 * var(--cb-spec-container-horizontal-padding)))',
                maxWidth: 'initial',
            },
        },
    ]);
};
export const StyledSearchField = styled.div `
  padding: ${({ theme }) => theme.spacing[100]};
  margin: ${({ theme }) => theme.spacing[0]};
  width: 100%;

  ${({ theme }) => theme.breakpoint.minWidth('md')} {
    margin: 0 ${({ theme }) => theme.spacing[200]};
    width: 100%;
  }
`;
//# sourceMappingURL=Typeahead.styled.js.map